import { createClient } from '@/shared/api';
import type { LatestAppVersionQuery, LatestAppVersionQueryVariables } from '@/shared/api';
import LATEST_APP_VERSION_QUERY from '../queries/latestAppVersion';

/**
 * Looks up the latest released version of a mobile app on a platform, feeding the update prompt. Builds a client that carries no token and skips auth, runs LATEST_APP_VERSION_QUERY, throws the returned message on failure and hands back latestVersion.
 *
 * @param appName - Name of the app to check.
 * @param platform - Platform the version is requested for.
 * @returns The latest released version string.
 */
const fetchLatestAppVersion = async (appName: string, platform: string) => {
  const client = createClient({ isUsingToken: false, isSkippingAuth: true });
  const latestAppVersionResult = await client.query<
    LatestAppVersionQuery,
    LatestAppVersionQueryVariables
  >({
    query: LATEST_APP_VERSION_QUERY,
    variables: {
      appName,
      platform,
    },
  });
  const { data } = latestAppVersionResult;
  const { latestAppVersion } = data;
  if (!latestAppVersion.isSuccess) {
    throw new Error(latestAppVersion.message ?? undefined);
  }
  return latestAppVersion.latestVersion;
};

export default fetchLatestAppVersion;
